export default {"src":"/_next/static/media/icon_expand_more.48d11826.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};